export const redirectToResponse = response => {
  const { headers } = response;

  const getFromHeader = header => {
    return headers.has(header) ? headers.get(header) : null;
  };

  const location = getFromHeader('location') || getFromHeader('Location');
  if (location) {
    window.location.replace(location);
  } else {
    window.location.reload(true);
  }
};



// WEBPACK FOOTER //
// ./src/utils/redirect.js